import { Target, Activity, Brain, Flame } from "lucide-react";

const FEATURES = [
  {
    icon: Target,
    title: "Skill Development",
    description:
      "Sharpen ball handling, shooting mechanics, finishing, and elite-level scoring.",
  },
  {
    icon: Activity,
    title: "Athletic Performance",
    description:
      "Build explosive speed, vertical, agility, and basketball-specific strength.",
  },
  {
    icon: Brain,
    title: "Basketball IQ",
    description:
      "Master spacing, reads, decision-making, and the modern positionless game.",
  },
  {
    icon: Flame,
    title: "Elite Mindset",
    description:
      "Develop the confidence, discipline, and leadership of high-level athletes.",
  },
];

export const FeatureStrip = () => {
  return (
    <section
      data-testid="feature-strip"
      className="bg-[#070B14] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                data-testid={`feature-card-${i}`}
                className="group bg-[#070B14] p-8 hover:bg-[#0a1020] transition-colors"
              >
                <div className="w-12 h-12 flex items-center justify-center border border-white/10 text-[#60A5FA] group-hover:border-[#2563EB] group-hover:text-[#2563EB] transition-colors">
                  <Icon size={22} strokeWidth={1.6} />
                </div>
                <h3 className="font-display mt-6 text-xl font-bold uppercase tracking-tight">
                  {f.title}
                </h3>
                <p className="mt-3 text-[#A1A1AA] text-sm leading-relaxed">
                  {f.description}
                </p>
                <div className="mt-6 text-[10px] tracking-[0.3em] text-white/30 uppercase">
                  0{i + 1} / 04
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeatureStrip;
